<layout-page-container>
  <layout-header-container title="Tags"/>

  <layout-form-container (clear)="reset()"
                         (searchValueChange)="FilterTag($event)" (submit)="AddTag()"
                         [element]="name" [permission]="PermissionService.Inventory_Tag_Add()"
                         clearText="Werte zurücksetzen"
                         submitText="Tag anlegen">
    <div class="grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-6">
      <div class="sm:col-span-5">
        <label class="block text-sm font-medium leading-6 text-gray-900" for="tag-name">Name</label>
        <input #name [(ngModel)]="newTagName"
               autocomplete="tag-name"
               class="mt-2 block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6"
               id="tag-name" name="tag-name"
               type="text">
      </div>
      <div class="">
        <label class="block text-sm font-medium leading-6 text-gray-900" for="tag-name">Farbe</label>
        <input #color
               autocomplete="tag-color"
               class="mt-2 block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6"
               id="NewTagColor" name="tag-color"
               type="color">
      </div>
      <div class="sm:col-span-6 inline-flex gap-x-2">
        <button (click)="newTagDisabledFlag = !newTagDisabledFlag" [class.!bg-theme-primary-700]="newTagDisabledFlag"
                [disabled]="newTagDisabledFlagDisabled"
                aria-checked="false"
                class="disabled:opacity-25 bg-gray-200 relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-theme-primary-700 focus:ring-offset-2"
                id="tag-disabled"
                name="tag-disabled"
                role="switch" type="button">
          <!-- Enabled: "translate-x-5", Not Enabled: "translate-x-0" -->
          <span [class.!translate-x-5]="newTagDisabledFlag" aria-hidden="true"
                class="translate-x-0 pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"></span>
        </button>
        <label class="block text-sm font-medium leading-6 text-gray-900 select-none"
               for="tag-disabled">Deaktiviert</label>
      </div>
      <div class="sm:col-span-6 inline-flex gap-x-2">
        <button (click)="SetOtherTag(!newTagOthersFlag)" [class.!bg-theme-primary-700]="newTagOthersFlag"
                [disabled]="newTagOthersFlagDisabled"
                aria-checked="false"
                class="bg-gray-200 relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-theme-primary-700 focus:ring-offset-2"
                id="tag-other"
                name="tag-other"
                role="switch" type="button">
          <!-- Enabled: "translate-x-5", Not Enabled: "translate-x-0" -->
          <span [class.!translate-x-5]="newTagOthersFlag" aria-hidden="true"
                class="disabled:opacity-25 translate-x-0 pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"></span>
        </button>
        <label class="block text-sm font-medium leading-6 text-gray-900 select-none"
               for="tag-other">Sonstiges</label>
      </div>
      <div class="sm:col-span-6 inline-flex gap-x-2">
        <button (click)="SetAllCompositionsTag(!newTagAllCompositionsFlag)"
                [class.!bg-theme-primary-700]="newTagAllCompositionsFlag" [disabled]="newTagAllCompositionsFlagDisabled"
                aria-checked="false"
                class="bg-gray-200 relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-theme-primary-700 focus:ring-offset-2"
                id="tag-all-included"
                name="tag-all-included"
                role="switch" type="button">
          <!-- Enabled: "translate-x-5", Not Enabled: "translate-x-0" -->
          <span [class.!translate-x-5]="newTagAllCompositionsFlag" aria-hidden="true"
                class="translate-x-0 pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"></span>
        </button>
        <label class="block text-sm font-medium leading-6 text-gray-900 select-none"
               for="tag-all-included">Alles inkludieren</label>
      </div>
    </div>
  </layout-form-container>

  <layout-page-scrollable>
    <app-loading *ngIf="tags == undefined"></app-loading>
    <div class="w-full overflow-x-auto flex">
      <table *ngIf="filtered_tags && filtered_tags.length > 0"
             class="w-full divide-y divide-gray-300">
        <thead>
        <tr>
          <th (click)="SortBy('name')" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-2"
              scope="col">
            <div class="inline-flex">
              <div class="grid grid-cols-1 gap-1">
                <svg [class.opacity-100]="field == 'name' && !inverse"
                     class="place-self-center bi bi-arrow-down opacity-50 -mb-1"
                     height="16" viewBox="0 0 16 16"
                     width="16" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                </svg>
                <svg [class.opacity-100]="field == 'name' && inverse"
                     class="place-self-center bi bi-arrow-down opacity-50 -mt-1"
                     height="16" viewBox="0 0 16 16"
                     width="16" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                </svg>
              </div>
              <a
                class="cursor-pointer select-none place-self-center pl-2 text-sm text-theme-primary-700 hover:text-theme-primary-900 cursor-pointer">Name</a>
            </div>
          </th>
          <th (click)="SortBy('order')" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0"
              scope="col">
            <div class="inline-flex">
              <div class="grid grid-cols-1 gap-1">
                <svg [class.opacity-100]="field == 'order' && !inverse"
                     class="place-self-center bi bi-arrow-down opacity-50 -mb-1"
                     height="16" viewBox="0 0 16 16"
                     width="16" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                </svg>
                <svg [class.opacity-100]="field == 'order' && inverse"
                     class="place-self-center bi bi-arrow-down opacity-50 -mt-1"
                     height="16" viewBox="0 0 16 16"
                     width="16" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                </svg>
              </div>
              <a
                class="cursor-pointer select-none place-self-center pl-2 text-sm text-theme-primary-700 hover:text-theme-primary-900 cursor-pointer">R</a>
            </div>
          </th>
          <th (click)="SortBy('created')"
              class="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell"
              scope="col">
            <div class="inline-flex">
              <div class="grid grid-cols-1 gap-1">
                <svg [class.opacity-100]="field == 'created' && !inverse"
                     class="place-self-center bi bi-arrow-down opacity-50 -mb-1"
                     height="16" viewBox="0 0 16 16"
                     width="16" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                </svg>
                <svg [class.opacity-100]="field == 'created' && inverse"
                     class="place-self-center bi bi-arrow-down opacity-50 -mt-1"
                     height="16" viewBox="0 0 16 16"
                     width="16" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                </svg>
              </div>
              <a
                class="cursor-pointer select-none place-self-center pl-2 text-sm text-theme-primary-700 hover:text-theme-primary-900">Erstellt
                am</a>
            </div>
          </th>
          <th class="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 lg:table-cell" scope="col">Flag /
            ID
          </th>
          <th *ngIf="PermissionService.CheckPermission(PermissionService.CombinedPermission_TagSetFilter())"
              class="px-3 py-3.5 text-left font-semibold text-gray-900 text-sm"
              scope="col">Filter
          </th>
          <th class="relative py-3.5 pl-3 pr-4 sm:pr-0 text-lg" scope="col">
            <span class="sr-only">Edit</span>
          </th>
        </tr>
        </thead>
        <tbody class="divide-y divide-gray-200 bg-white">
          @for (tag of filtered_tags; track tag.id; let index = $index) {
            <tr>
              <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-2">
                <a
                  [ngClass]="{'pointer-events-none' : !PermissionService.CheckPermission(PermissionService.CombinedPermission_TagRedirectComposition()) || tag.allCompositions }"
                  [queryParams]="tag.other ? {other: tag.other, tag: tag.id }:{  other: tag.other, tag: tag.id }"
                  [routerLink]="['/compositions']"
                  [style.color]="'#' + tag.color">
                <span
                  class="inline-flex items-center rounded-full px-3 py-0.5 text-sm font-medium border-2 border-gray-900 max-w-full"
                  style="{{'border-color: #' + tag.color}}">
                  <svg class="-ml-1 mr-1.5 h-2 w-2" style="{{'border-color: #' + tag.color}}"
                       viewBox="0 0 8 8">
                    <circle cx="4" cy="4" r="3"/>
                  </svg>
                  <span class="d-inline-flex md:text-lg truncate" href=""
                        style="{{'color: #' + tag.color}}">{{ tag.name }}</span>
                </span>
                </a>
              </td>
              <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0">
                <span>{{ tag.order }}</span>
              </td>
              <td
                class="hidden whitespace-nowrap px-3 py-4 text-sm text-gray-500 sm:table-cell">{{ (tag.created) | date : "dd.MM.yyyy, HH:mm" }}
                Uhr
              </td>
              <td class="hidden whitespace-nowrap px-3 py-4 text-sm text-gray-500 lg:table-cell">
                <span *ngIf="tag.disabled" class="fw-bold text-red-400">D&nbsp;</span>
                <span *ngIf="tag.other" class="fw-bold text-yellow-600">S&nbsp;</span>
                <span *ngIf="tag.allCompositions" class="fw-bold text-blue-600">A&nbsp;</span>
                {{ tag.id }}
              </td>
              <td *ngIf="PermissionService.CheckPermission(PermissionService.CombinedPermission_TagSetFilter())"
                  class="whitespace-nowrap px-3 text-sm text-gray-500">
                <div>
                  <!-- Assign first, then handle: one listener, so the order of the bindings cannot change the
                       value `onFilterChange` (or its error rollback) sees (#267). -->
                  <select (ngModelChange)="filtered_tags[index].showFilter = $event; onFilterChange(tag, $event)"
                          [ngModel]="filtered_tags[index].showFilter"
                          class="block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-theme-primary-700 sm:text-sm sm:leading-6"
                          id="filter"
                          name="filter">
                    <option [selected]="tag.filter == undefined" value="none">-- KEINER --</option>
                    <option *ngFor="let category of categories"
                            [selected]="tag.filter != undefined && category.id == tag.filter.id"
                            [value]="category.id">{{ category.name }}
                    </option>
                  </select>
                </div>
              </td>
              <td class="whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-0 sm:pl-2">
                <a (click)="redirectToSettings(tag.id)"
                   *ngIf="PermissionService.CheckPermission(PermissionService.Inventory_Tag_Get())"
                   class="select-none text-gray-600 hover:text-gray-900 cursor-pointer p-1  inline-flex">
                  <svg class="bi bi-trash3" height="20" viewBox="0 0 16 16" width="20"
                       xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001zm-.644.766a.5.5 0 0 0-.707 0L1.95 11.756l-.764 3.057 3.057-.764L14.44 3.854a.5.5 0 0 0 0-.708l-1.585-1.585z"/>
                  </svg>
                </a>
                <a (click)="RemoveTag(tag)"
                   *ngIf="PermissionService.CheckPermission(PermissionService.Inventory_Tag_Delete())"
                   class="select-none text-red-600 hover:text-red-900 cursor-pointer p-1 inline-flex">
                  <svg class="bi bi-trash3" height="20" viewBox="0 0 16 16" width="20"
                       xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z"/>
                  </svg>
                </a>

              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </layout-page-scrollable>
</layout-page-container>

